import { VolumeItem, VolumeMountTab, VolumeMountType } from './_hooks';

export const genSyncTimezoneItem = (containerName: string): VolumeItem => ({
  selected: undefined,
  volumeHostPath: '/etc/localtime',
  volumeName: 'host-time',
  type: VolumeMountTab.HOST_PATH,
  volumeMounts: [
    { containerName, mountType: VolumeMountType.ReadOnly, mountPath: '/etc/localtime' },
  ],
});

export function genSyncTimezoneVolumeMountItem(containerName: string) {
  return { containerName, mountType: VolumeMountType.ReadOnly, mountPath: '/etc/localtime' };
}
